export function makeFilterCache<T>(key: string) {
  return {
    read(): T | null {
      try {
        const raw = localStorage.getItem(key);
        return raw ? (JSON.parse(raw) as T) : null;
      } catch {
        return null;
      }
    },
    write(value: T): void {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {
        /* no-op */
      }
    },
    clear(): void {
      try {
        localStorage.removeItem(key);
      } catch {
        /* no-op */
      }
    },
  };
}
